import { EAppointmentSlot } from "@constants";
import { slotCodeToLabel } from "../mappers/mapAvailableAppointmentList";

/**
 * Maps time slot label to API code (AM, PM, or AD)
 */
export const mapTimeSlotLabelToCode = (timeSlotLabel: string): EAppointmentSlot => {
    if (timeSlotLabel.includes("Morning") && timeSlotLabel.includes("Afternoon")) {
        return EAppointmentSlot.AD;
    }
    if (timeSlotLabel.includes("Morning")) {
        return EAppointmentSlot.AM;
    }
    if (timeSlotLabel.includes("Afternoon")) {
        return EAppointmentSlot.PM;
    }

    return EAppointmentSlot.AD;
};

/**
 * Maps API code (AM, PM, or AD) to time slot label
 * @param slotCode - The appointment slot code
 * @returns The first available label for the slot code, or empty string if not found
 */
export const mapTimeSlotCodeToLabel = (slotCode: EAppointmentSlot): string => {
    const labels = slotCodeToLabel[slotCode];

    return labels?.[0] ?? "";
};
